function CategorySection({ title, children, rightContent = null }) {
  return (
    <section style={{ marginTop: "32px" }}>
      <div style={header}>
        <h2 style={titleStyle}>{title}</h2>
        {rightContent ? <div>{rightContent}</div> : null}
      </div>
      {children}
    </section>
  );
}

const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  marginBottom: "16px",
  flexWrap: "wrap",
};

const titleStyle = {
  margin: 0,
  fontSize: "28px",
};

export default CategorySection;